import { ajax } from 'rxjs/ajax';

const getPreArrivalPreference$ = ({ bookingId }) =>
	ajax.getJSON(`/api/preArrivalPreference/${bookingId}`, {
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json',
		},
	});

export default getPreArrivalPreference$;
